import React, { useEffect, useState } from 'react';
import {
  Button,
  InlineLoading,
  InlineNotification
} from 'carbon-components-react';
import { SCREEN_SIZE } from 'types';

const ArchiveSeries: React.FC<Props> = ({
  onClose,
  enquiryId,
  enquiryAutoRenewSeries,
  isArchive,
  archiveEnquiry,
  isArchivingEnquiry,
  archivedEnquiry,
  screenSize
}) => {
  const [disableArchiveButton, setDisableArchiveButton] =
    useState<boolean>(false);
  const [localArchive, setLocalArchive] = useState<boolean>(false);
  const [isMultiple, setIsMultiple] = useState<boolean>(true);

  const handleArchiveClick = (withSeries: boolean) => {
    setLocalArchive(true);
    setDisableArchiveButton(true);
    let enquiryIdArray = [];

    if (withSeries) {
      enquiryIdArray = enquiryAutoRenewSeries.map((ar) => ar.id);
      setIsMultiple(true);
    } else {
      setIsMultiple(false);
    }
    archiveEnquiry(enquiryId, enquiryIdArray, isArchive);
  };

  useEffect(() => {
    if (isArchivingEnquiry) {
      setDisableArchiveButton(true);
    }

    if (!isArchivingEnquiry && archivedEnquiry) {
      setTimeout(() => {
        setDisableArchiveButton(false);
        setLocalArchive(false);
        onClose();
      }, 1500);
    }
    // eslint-disable-next-line
  }, [isArchivingEnquiry, archivedEnquiry]);

  return (
    <div className={`archive-enquiry-series`}>
      <div className="inline-notification-container">
        <InlineNotification
          kind="info"
          lowContrast
          hideCloseButton={true}
          className="inline-notification"
          title={'This enquiry is part of a series'}
        />
      </div>
      <div className={`archive-enquiry-series-wrapper`}>
        <div className="archive-enquiry-series-button-container">
          <Button
            kind={screenSize === SCREEN_SIZE.SM ? 'tertiary' : 'ghost'}
            disabled={disableArchiveButton || isArchivingEnquiry}
            onClick={() => handleArchiveClick(false)}
          >
            {!isArchivingEnquiry && !localArchive ? (
              `${isArchive ? 'Archive' : 'Restore'} only this enquiry`
            ) : (isArchivingEnquiry && !isMultiple) ||
              (localArchive && !isMultiple) ? (
              <InlineLoading
                description={`${
                  isArchive ? 'Archive' : 'Restore'
                } only this enquiry`}
                status={!isArchivingEnquiry ? 'finished' : 'active'}
                aria-live={'assertive'}
              />
            ) : (
              `${isArchive ? 'Archive' : 'Restore'} only this enquiry`
            )}
          </Button>

          <Button
            kind="secondary"
            disabled={disableArchiveButton || isArchivingEnquiry}
            onClick={() => handleArchiveClick(true)}
          >
            {!isArchivingEnquiry && !localArchive ? (
              `${isArchive ? 'Archive' : 'Restore'} series (${
                enquiryAutoRenewSeries.length
              })`
            ) : isMultiple ? (
              <InlineLoading
                description={`${isArchive ? 'Archive' : 'Restore'} series (${
                  enquiryAutoRenewSeries.length
                })`}
                status={!isArchivingEnquiry ? 'finished' : 'active'}
                aria-live={'assertive'}
              />
            ) : (
              `${isArchive ? 'Archive' : 'Restore'} series (${
                enquiryAutoRenewSeries.length
              })`
            )}
          </Button>
        </div>
      </div>
    </div>
  );
};

type Props = {
  onClose: Function;
  enquiryId: number;
  onRefreshTeamView: Function;
  enquiryAutoRenewSeries: any[];
  isArchive: boolean;
  archiveEnquiry: Function;
  isArchivingEnquiry?: boolean;
  archivedEnquiry: any;
  screenSize: any;
};

export default React.memo(ArchiveSeries);
